export default __webpack_public_path__ + "static/media/0174.b6135abc.jpg";